const get_started = {
    page_title: 'เริ่มต้น',
    title: 'บางสิ่งที่จะช่วยให้คุณประสบความสำเร็จ',
    subtitle: 'มีบางอย่างที่คุณสามารถทำได้เพื่อรับประโยชน์จาก Logto อย่างรวดเร็ว',
    develop: {
        title: 'พัฒนา: ใช้เวลา 5 นาทีในการเชื่อมต่อแอปของคุณ',
        title_cloud: 'พัฒนา: เชื่อมต่อแอปของคุณอย่างปลอดภัยภายในไม่กี่นาที',
        subtitle_cloud: 'หรือใช้เวลาเพียง 5 นาทีในการเชื่อมต่อแอปของคุณกับ SDK และคู่มือสำเร็จรูปของเรา',
        try_mcp: 'ลองรวมระบบด้วยคำสั่งเดียวกับ MCP',
    },
    customize: {
        title: 'ปรับแต่ง: มอบประสบการณ์การลงชื่อเข้าใช้ที่ยอดเยี่ยม',
        preview: {
            title: 'ตรวจสอบตัวอย่างสดของประสบการณ์การลงชื่อเข้าใช้ที่คุณเพิ่งปรับแต่ง',
            subtitle: 'ลองประสบการณ์ลงชื่อเข้าใช้ของ Logto ตอนนี้เพื่อดูว่ามันทำงานอย่างไร',
        },
        connector: {
            title: 'เพิ่มผู้เชื่อมต่อเพื่อรองรับการลงชื่อเข้าใช้ด้วยโซเชียลมากขึ้น',
            subtitle: 'ลองใช้การลงชื่อเข้าใช้แบบไม่ใช้รหัสผ่าน และมอบประสบการณ์ที่ปลอดภัยและราบรื่นให้กับลูกค้าของคุณ',
        },
        continue_customizing: 'ปรับแต่งต่อ',
        try_now: 'ลองเลย',
        add_more: 'เพิ่มเพิ่มเติม',
    },
    secure: {
        title: 'รักษาความปลอดภัย: ปกป้องทรัพยากรของคุณ',
    },
    manage: {
        title: 'จัดการ: กำหนดการควบคุมสิทธิ์สำหรับผลิตภัณฑ์และผู้ใช้ของคุณ',
        rbac: {
            title: 'เพิ่มการควบคุมการเข้าถึงตามบทบาทเพื่อปกป้องทรัพยากรของคุณ',
            subtitle: 'ควบคุมทรัพยากรของคุณผ่านการกำหนดสิทธิ์ตามบทบาทที่ขยายได้สำหรับกรณีการใช้งานที่หลากหลาย',
        },
        create_roles: 'สร้างบทบาท',
    },
    convert_to_production: {
        card_title: 'พร้อมสำหรับการใช้งานจริงหรือยัง? อย่าลืมตั้งค่าระบบสำหรับโปรดักชั่น!',
        title: 'อย่าให้โปรเจกต์ของคุณติดอยู่ในโหมด dev',
        subtitle: 'คุณกำลังใช้ tenant dev เพื่อทดสอบฟรี หากต้องการใช้งานจริง ให้สร้างหรือแปลงเป็น tenant โปรดักชั่น ต้องการคำปรึกษาเพิ่มเติมใช่ไหม <a>ติดต่อเรา</a>',
        convert_button: 'แปลงเป็น tenant โปรดักชั่น',
    },
    oss_cloud: {
        try: {
            title: 'ข้ามงานด้านปฏิบัติการ แล้วลองใช้ Logto Cloud ฟรี',
            badge: 'แนะนำ',
            description: 'รับ Logto แบบดูแลให้ทั้งหมดโดยไม่ต้องบำรุงรักษา พร้อมการผสานรวมอย่างรวดเร็วด้วย MCP การรองรับหลายเทนเนนต์ การทำงานร่วมกันของทีม และฟีเจอร์พรีเมียมทั้งหมดในแพ็กเกจ เริ่มต้นได้ฟรีโดยไม่ต้องใช้บัตรเครดิต',
            action: 'สำรวจ Logto Cloud',
        },
        private_cloud: {
            title: 'ต้องการ compliance หรือการติดตั้งใช้งานแบบกำหนดเองหรือไม่?',
            card_title: 'Private cloud',
            description: 'รับอินสแตนซ์ Logto แบบเฉพาะพร้อมการแยกข้อมูลอย่างสมบูรณ์ โดเมนแบบกำหนดเอง และการรับประกัน SLA เหมาะสำหรับองค์กรที่มีข้อกำหนดด้านการจัดเก็บข้อมูลหรือ compliance ที่เข้มงวด เราดูแลโครงสร้างพื้นฐานให้ คุณจึงโฟกัสกับผลิตภัณฑ์ได้เต็มที่',
        },
        sidebar: {
            title: 'โฟกัสกับการพัฒนา ไม่ใช่การโฮสต์',
            description: 'ให้ Logto Cloud ดูแลโครงสร้างพื้นฐานด้านการยืนยันตัวตนให้คุณ',
            action: 'ลองใช้ Logto Cloud',
        },
    },
    view_all: 'ดูทั้งหมด →',
};
export default Object.freeze(get_started);
